import { useEffect, useState } from 'react';
import { useRequest } from '@fuxi/eevee-hooks';
import { get, set } from 'lodash-es';
import { MonorepoType } from '@yaotai/common-utils';
import { CommonAPI } from '../services';
import { SwitchConfItem, SwitchTypeKeys, DEFAULT_ICO } from '../constants';

export const useBulkFeatureSwitch = ({
  aid,
  switchGroups,
  monorepoType,
}: {
  aid?: string;
  monorepoType?: MonorepoType;
  switchGroups?: number[];
}) => {
  const [state, setState] = useState({});

  const { loading, run } = useRequest(
    aid => {
      return CommonAPI.current!.activity!.getBulkFeatureSwitch(aid, switchGroups);
    },
    {
      manual: true,
      onSuccess: result => {
        // 请求成功后，center项目如果未配置oem的 favicon,则设置默认瑶台favicon
        if (monorepoType === 'center' && !get(result, 'data.OEM.oem_icon_logo.detail')) {
          setDefaultOemLogo(result);
        } else {
          setState(result);
        }
      },
      onError: error => {
        // 请求失败后设置 默认favicon
        setDefaultOemLogo();
      },
    },
  );

  const bulkSwitchConf = get(state, 'data', {}) as Record<Partial<SwitchTypeKeys>, { [key: string]: SwitchConfItem }>;

  // 设置默认站点favicon.ico; center项目 中会丢给 useFavicon 处理
  const setDefaultOemLogo = (obj = {}) => {
    set(obj, 'data.OEM.oem_icon_logo.detail', DEFAULT_ICO);
    setState(obj);
  };

  useEffect(() => {
    if (!aid) return;
    run(aid);
  }, [aid]);

  return {
    bulkSwitchConf,
    bulkLoading: loading,
  };
};
